import styled from 'styled-components';

export default styled.div`

    .box {
        height: 115px;
        background-color: #CBD7E0;
        .jobTitle {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            margin-bottom: 0;
            font-weight: bold;
        }
        .compensation {
            font-weight: bold;
        }
    }

`